import React, {useState} from "react";
import "./PointEdit.css";
import Form from "react-bootstrap/Form";
import {Field, useFormikContext} from "formik";
import {Button, Modal} from "react-bootstrap";
import {useEditContext} from "./EditContext";
import {WalkMap} from "./types";
import Markdown from "react-markdown";

type PointEditProps = {
  index: number;
};

const PointEdit = ({index}: PointEditProps) => {
  const {setUpdatingCoordinate, setEditNode} = useEditContext();
  const {values: walkMap} = useFormikContext<WalkMap>();
  const [showPreview, setShowPreview] = useState(false);
  const handleClosePreview = () => setShowPreview(false);
  const handleShowPreview = () => setShowPreview(true);

  return (
    <div className="PointEdit">
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Name</Form.Label>
          <Field
            className="form-control"
            type="text"
            name={`points.${index}.name`}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <div className="PointItem-preview-row">
            <Form.Label>Content</Form.Label>
            <Button variant="success" onClick={handleShowPreview}>
              Preview
            </Button>
          </div>
          <Field
            className="form-control"
            as="textarea"
            type="text"
            name={`points.${index}.content`}
          />
        </Form.Group>
        <Button
          variant="secondary"
          onClick={() => {
            setUpdatingCoordinate(index);
            setEditNode(null);
          }}>
          Update Coordinate
        </Button>
      </Form>

      <Modal show={showPreview} onHide={handleClosePreview}>
        <Modal.Header closeButton>
          <Modal.Title>Content Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Markdown>{walkMap.points[index].content || "Empty"}</Markdown>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePreview}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PointEdit;
